var _script, _script2, _g, _defs, _script3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdaiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    "data-extension-id": "dlcobpjiigpikoobohmabehhmhfoodbb"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 600c165.685 0 300-134.315 300-300S465.685 0 300 0 0 134.315 0 300s134.315 300 300 300Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9 250.5h-35.6c-19.6-54.4-72.3-91.7-141.8-91.7H186.2v91.7h-39.7v32.9h39.7v34.5h-39.7v32.9h39.7v90.6h114.3c68.7 0 121-37 141.1-90.6h36.3v-32.9h-28.3c.7-5.8 1.1-11.8 1.1-17.8v-.8c0-5.4-.3-10.7-.8-15.9H478v-32.9h-.1Zm-259.7-62.4h82.3c51 0 88.9 25.1 106.4 62.3H218.2v-62.3Zm82.3 223.7h-82.3v-61.1h188.5c-17.6 36.6-55.4 61.1-106.2 61.1Zm117.1-111c0 5.8-.4 11.5-1.2 17H218.2v-34.5h198.3c.7 5.4 1.1 11 1.1 16.7v.8Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 300,
    y1: -85,
    x2: 300,
    y2: 663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC34A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h600v600H0z"
  })))), _script3 || (_script3 = /*#__PURE__*/React.createElement("script", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdaiLogo);
export default __webpack_public_path__ + "static/media/sdai-logo.7ca44eb8eb0b8925a3f09059281ff73d.svg";
export { ForwardRef as ReactComponent };